var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qr-section-wrapper content-wrapper"},[_c('progress-bar',{attrs:{"currentStep":2}}),_c('div',{staticClass:"header-request"},[_c('h3',[_vm._v(_vm._s(_vm.instruction.message))])]),_c('div',{staticClass:"qr-img-wrapper"},[_c('img',{staticClass:"qr-img",attrs:{"src":_vm.instruction.options,"alt":"QR Code"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }